import Player from '@vimeo/player';

import {
    gsapTimelinePromise,
    lockBodyScroll,
    unlockBodyScroll,
} from '../../../common/utils';

import scrollSmoother from '../../../behavior/scroll-smoother';

import cursor from '../../../components/cursor';

import header from '../../../components/header';

import els from './elements';

let player = null;

const resizeFrame = () => {

    const $frame = els.$frame();

    const windowWidth = $(window).width();
    const windowHeight = $(window).height();

    let intendedFrameWidth = windowWidth;
    let intendedFrameHeight = windowWidth * 9/16;

    if (intendedFrameHeight > windowHeight) {
        intendedFrameHeight = windowHeight;
        intendedFrameWidth = windowHeight * 16/9;
    }

    gsap.set(
        $frame,
        {
            width: intendedFrameWidth,
            height: intendedFrameHeight,
            xPercent: -50,
            yPercent: -50,
        }
    );
};

const initializePlayer = async () => {

    const iframe = els.$iframe().get(0);

    player = new Player(iframe);

    await player.ready();
};

const handleResize = async () => {

    resizeFrame();
};

const show = async () => {

    const $popup = els.$popup();

    const timeline = gsap.timeline();

    timeline.to($popup, { autoAlpha: 1 });

    await gsapTimelinePromise(timeline);
};

const hide = async () => {

    const $popup = els.$popup();

    const timeline = gsap.timeline();

    timeline.to($popup, { autoAlpha: 0 });

    await gsapTimelinePromise(timeline);
};

const positionPopup = () => {

    const $popup = els.$popup();

    gsap.set(
        $popup,
        { top: scrollSmoother.getInstance().scrollTop() }
    );
};

const initialize = async () => {

    const $hero = els.$hero();
    const $popup = els.$popup();
    const $closeButton = els.$closeButton();
    const $clickout = els.$clickout();

    await initializePlayer();

    resizeFrame();

    $popup.on('mousemove', (event) => {
        event.stopPropagation();
    });

    $hero.on('click', async () => {

        lockBodyScroll();

        positionPopup();

        header.hide();

        await show();

        cursor.styleForDefault();

        player.play();
    });

    $closeButton
        .add($clickout)
        .on('click', async (event) => {

            event.stopPropagation();

            player.pause();

            await hide();

            unlockBodyScroll();

            header.show();
        });
};

export default {
    initialize,
    handleResize,
};

